module.exports = __webpack_public_path__ + "img/icon-warning-vind-4.6ff90b1b.svg";